import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderBest from './header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Lightbox from "yet-another-react-lightbox";
import incotermsImg from '../assets/img/mitinco.png';
import "yet-another-react-lightbox/styles.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
// Modal için root element'i ayarla

// Modal stilleri

function Databank() {
  const [length, setLength] = useState('');
  const [width, setWidth] = useState('');
  const [height, setHeight] = useState('');
  const [packageCount, setPackageCount] = useState('1');
  const [stackable, setStackable] = useState('');
  const [ldm, setLdm] = useState('-');
  const [truckWidth, setTruckWidth] = useState(0);
  const [activeTab, setActiveTab] = useState('LDM');
  const [unit, setUnit] = useState(1);
  const [cbm, setCbm] = useState('0.000');
  const [cft, setCft] = useState('0.000');
  const [cyd, setCyd] = useState('0.000');
  const [cin, setCin] = useState('0.000');
  const [ccm, setCcm] = useState('0.000');
  const [sea, setSea] = useState('0.000');
  const [air, setAir] = useState('0.000');
  const [gt20, setGt20] = useState('NaN');
  const [gt40, setGt40] = useState('NaN');
  const [rt20, setRt20] = useState('NaN');
  const [rt40, setRt40] = useState('NaN');
  const [hc20, setHc20] = useState('NaN');
  const [hc40, setHc40] = useState('NaN');
  const [email, setEmail] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxSrc, setLightboxSrc] = useState('');
  // Incoterms açılır kapanır menü durumu için state
  const [activeAccordion, setActiveAccordion] = useState('');

  const calculateLDM = () => {
    let p1 = parseFloat(length);
    let p2 = parseFloat(width);
    let p4 = parseFloat(packageCount);
    let p5 = stackable;
    let p61 = (p1 * p2 * p4) / 2.4 / 10000;
    if (p5 === 'EVET') {
      p61 = p61 / 2;
    }
    let p6 = Math.round(p61 * 100) / 100;
    if (isNaN(p6)) {
      p6 = '-';
    }
    setLdm(p6);
    if (p6 > 13.6) p6 = 13.6;
    setTruckWidth((503 * p6) / 13.6);
  };

  const calculateVolume = () => {
    const Length = parseFloat(length) || 0;
    const Width = parseFloat(width) || 0;
    const Height = parseFloat(height) || 0;
    const qua = parseFloat(packageCount) || 1;
    let interest;

    switch (unit) {
      case 1:
        interest = qua * ((100 * Length) * (100 * Width) * (100 * Height));
        break;
      case 2:
        interest = qua * (Length * Width * Height);
        break;
      case 3:
        interest = qua * ((0.1 * Length) * (0.1 * Width) * (0.1 * Height));
        break;
      case 4:
        interest = qua * ((30.48 * Length) * (30.48 * Width) * (30.48 * Height));
        break;
      case 5:
        interest = qua * ((2.54 * Length) * (2.54 * Width) * (2.54 * Height));
        break;
      case 6:
        interest = qua * ((91.44 * Length) * (91.44 * Width) * (91.44 * Height));
        break;
      default:
        interest = qua * ((100 * Length) * (100 * Width) * (100 * Height));
    }

    const cfttotal = (interest / (30.48 * 30.48 * 30.48)).toFixed(3);
    const cbmtotal = (interest / 1000000).toFixed(3);
    const cydtotal = (interest / (91.44 * 91.44 * 91.44)).toFixed(3);
    const cintotal = (interest / (2.54 * 2.54 * 2.54)).toFixed(3);
    const ccmtotal = (interest / (1 * 1 * 1)).toFixed(3);
    const sea = (interest / 5000).toFixed(3);
    const air = (interest / 6000).toFixed(3);

    // Konteyner hesaplamaları
    const totalg20 = isNaN(cbmtotal) ? 'NaN' : parseInt(30.423 / cbmtotal);
    const totalg40 = isNaN(cbmtotal) ? 'NaN' : parseInt(61.943 / cbmtotal);
    const totalr20 = isNaN(cbmtotal) ? 'NaN' : parseInt(28.352 / cbmtotal);
    const totalr40 = isNaN(cbmtotal) ? 'NaN' : parseInt(57.8 / cbmtotal);
    const totalhc20 = isNaN(cbmtotal) ? 'NaN' : parseInt(34.708 / cbmtotal);
    const totalhc40 = isNaN(cbmtotal) ? 'NaN' : parseInt(70.668 / cbmtotal);

    setCft(cfttotal);
    setCbm(cbmtotal);
    setCyd(cydtotal);
    setCin(cintotal);
    setCcm(ccmtotal);
    setSea(sea);
    setAir(air);
    setGt20(totalg20);
    setGt40(totalg40);
    setRt20(totalr20);
    setRt40(totalr40);
    setHc20(totalhc20);
    setHc40(totalhc40);
  };
  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    toast.success('Email successfully subscribed!');
    setEmail('');
  };
  // Birim değiştiğinde hesaplama yap
  useEffect(() => {
    if (activeTab === 'Volume') {
      calculateVolume();
    }
  }, [unit, length, width, height, packageCount]);

  // Accordion toggle fonksiyonu
  const toggleAccordion = (term) => {
    if (activeAccordion === term) {
      setActiveAccordion('');
    } else {
      setActiveAccordion(term);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleImageClick = () => {
    setLightboxSrc(incotermsImg);   // 👈 resmi ata
    setIsOpen(true);
  };

  return (
    <>
       <ToastContainer 
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{
          zIndex: 9999,
          fontSize: '14px',
          width: 'auto',
          maxWidth: '400px'
        }}
      />
      <div id="preloader" style={{ display: "none" }}>
        <div className="tg-preloader-block">
          <div className="tg-spinner-eff">
            <div className="tg-bar tg-bar-top" />
            <div className="tg-bar tg-bar-right" />
            <div className="tg-bar tg-bar-bottom" />
            <div className="tg-bar tg-bar-left" />
          </div>
        </div>
      </div>

      <button className="scroll__top scroll-to-target open" data-target="html" onClick={scrollToTop}>
        <i className="fas fa-angle-up" />
      </button>

      <HeaderBest/>

      <main className="fix">
        <section
          className="breadcrumb__area breadcrumb__bg"
          data-background="assets/img/bg/breadcrumb_bg.jpg"
          style={{ backgroundImage: 'url("assets/img/breadcrumb_bg.jpg")' }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="breadcrumb__content">
                  <h1 className="title">Databank</h1>
                  <nav className="breadcrumb">
                    <span property="itemListElement" typeof="ListItem">
                      <Link to="/">Home</Link>
                    </span>
                    <span className="breadcrumb-separator">
                      <i className="flaticon-right-arrow" />
                    </span>
                    <span property="itemListElement" typeof="ListItem">
                      Databank
                    </span>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="container no-sidebar has-title">
          <div className="vc_row wpb_row vc_row-fluid">
            <div className="wpb_column vc_column_container vc_col-sm-12">
              <div className="vc_column-inner">
                <div className="wpb_wrapper">
                  <div className="vc_row wpb_row vc_inner vc_row-fluid">
                    <div className="wpb_column vc_column_container vc_col-sm-8">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="calculator-container">
                            <div className="calculator-box">
                              <div className="tab-buttons">
                                <button onClick={() => setActiveTab('LDM')} className={activeTab === 'LDM' ? 'tabbuttonsroww' : ''}>LDM Calculation</button>
                                <div className="grayara"></div>
                                <button onClick={() => setActiveTab('Volume')} className={activeTab === 'Volume' ? 'tabbuttonsroww' : ''}>CBM Calculation</button>
                                <div className="grayara"></div>

                                <button onClick={() => setActiveTab('Incoterms')} className={activeTab === 'Incoterms' ? 'tabbuttonsroww' : ''}>Incoterms</button>
                              </div>
                              {activeTab === 'LDM' && (
                                <div className="calculator-form">
                                  <h2 className="calculator-title">LDM Calculation (Road transport)</h2>
                                      <p className="mb-3">In road transport, the tonnage calculation is done in lademetre (Ldm) for loads that cannot be stacked on a vehicle.</p>
                                  <div className="row">
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label>Length (cm):</label>
                                        <input 
                                          type="text" 
                                          value={length}
                                          onChange={(e) => { setLength(e.target.value); calculateLDM(); }}
                                          className="form-control"
                                          placeholder="Length"
                                        />
                                      </div>
                                    </div>
                                    <div className="col-12 col-md-6 mb-3">
                                      <div className="form-group">
                                        <label>Width (cm):</label>
                                        <input 
                                          type="text" 
                                          value={width}
                                          onChange={(e) => { setWidth(e.target.value); calculateLDM(); }}
                                          className="form-control"
                                          placeholder="Width"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="row">

                                  <div className="col-12 col-md-6 mb-3">

                                  <div className="form-group">
                                    <label>Height (cm):</label>
                                    <input 
                                      type="text" 
                                      value={height}
                                      onChange={(e) => { setHeight(e.target.value); calculateLDM(); }}
                                      className="form-control"
                                      placeholder="Height"
                                    />
                                  </div>
                                  </div>
                                  <div className="col-12 col-md-6 mb-3">

                                  <div className="form-group">
                                    <label>Package Count (pcs):</label>
                                    <input 
                                      type="text" 
                                      value={packageCount}
                                      onChange={(e) => { setPackageCount(e.target.value); calculateLDM(); }}
                                      className="form-control"
                                      placeholder="Package Count"
                                    />
                                  </div>
                                  </div>
                                </div>
                                  <div className="form-group">
                                    <label>Can be stacked on top of each other?:</label>
                                    <select 
                                      value={stackable}
                                      onChange={(e) => { setStackable(e.target.value); calculateLDM(); }}
                                      className="form-control"
                                    >
                                      <option value="">Select</option>
                                      <option value="EVET">YES</option>
                                      <option value="HAYIR">NO</option>
                                    </select>
                                  </div>
                                  <div className="result-box">
                                    <h3>LDM Result:</h3>
                                    <div className="result-value">{ldm} LDM</div>
                                  </div>
                                
                          
                                </div>
                              )}
                              {activeTab === 'Volume' && (
                                <div className="calculator-form">
                                  <h2 className="calculator-title">CBM Calculation (Sea Transport)</h2>
                                  <div 
                                    className="text-center yl mt-2 py-2 calcdsad"
                              
                                  >
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio1"
                                        value={1}
                                        checked={unit === 1}
                                        onChange={() => setUnit(1)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio1"
                                      >
                                        Meter
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio2"
                                        value={2}
                                        checked={unit === 2}
                                        onChange={() => setUnit(2)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio2"
                                      >
                                        CM
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio3"
                                        value={3}
                                        checked={unit === 3}
                                        onChange={() => setUnit(3)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio3"
                                      >
                                        MM
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio4"
                                        value={4}
                                        checked={unit === 4}
                                        onChange={() => setUnit(4)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio4"
                                      >
                                        FT
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio5"
                                        value={5}
                                        checked={unit === 5}
                                        onChange={() => setUnit(5)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio5"
                                      >
                                        IN
                                      </label>
                                    </div>
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="inlineRadioOptions"
                                        id="inlineRadio6"
                                        value={6}
                                        checked={unit === 6}
                                        onChange={() => setUnit(6)}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor="inlineRadio6"
                                      >
                                        YD
                                      </label>
                                    </div>
                                  </div>
                                  <div className="form-group d-block d-md-none mobcalc">
  <label style={{fontSize:"16px",fontWeight:"bold"}} htmlFor="unitSelect">Select Unit</label>
  <select
    id="unitSelect"
    className="form-control"
    value={unit}
    style={{border:"1px solid red"}}
    onChange={(e) => setUnit(Number(e.target.value))}
  >
    <option value={1}>Meter</option>
    <option value={2}>CM</option>
    <option value={3}>MM</option>
    <option value={4}>FT</option>
    <option value={5}>IN</option>
    <option value={6}>YD</option>
  </select>
</div>
                                  <div className="row">
                                  <div className="col-12 col-md-6 mb-3">
                                 
                                  <div className="form-group">
                                    <label
                                      htmlFor="Length"
                                     
                                    >
                                      Length
                                    </label>
                                    <div >
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="Length"
                                        placeholder="Length"
                                        value={length}
                                        onChange={(e) => { setLength(e.target.value); calculateVolume(); }}
                                      />
                                    </div>
                                  </div>
                                  </div>
                                  <div className="col-12 col-md-6 mb-3">

                                  <div className="form-group">
                                    <label
                                      htmlFor="Width"
                                    >
                                      Width
                                    </label>
                                    <div >
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="Width"
                                        placeholder="Width"
                                        value={width}
                                        onChange={(e) => { setWidth(e.target.value); calculateVolume(); }}
                                      />
                                    </div>
                                  </div>
                                </div>
                                  </div>

                                  <div className="row">

                                  <div className="col-12 col-md-6 mb-3">
                                    <label
                                      htmlFor="Height"
                                   
                                    >
                                      Height
                                    </label>
                                    <div >
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="Height"
                                        placeholder="Height"
                                        value={height}
                                        onChange={(e) => { setHeight(e.target.value); calculateVolume(); }}
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-6 mb-3">
                                    <label
                                      htmlFor="q1"
                                  
                                    >
                                      Quantity
                                    </label>
                                    <div >
                                      <input
                                        type="tel"
                                        className="form-control"
                                        id="q1"
                                        placeholder="Quantity"
                                        value={packageCount}
                                        onChange={(e) => { setPackageCount(e.target.value); calculateVolume(); }}
                                      />
                                    </div>
                                  </div>
                                  </div>


                                  <div className="blue rounded pb-2" style={{ background: "rgb(222 225 228)", padding: "15px", borderRadius: "5px" }}>
                                    <div className="row text-white justify-content-center mt-2 c-row">
                                      <p className="fs-6 text-center ylfont fw-bold m-0 mt-1 c-col-t">
                                        Cubic Calculation
                                      </p>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm cbm c-col-t-1">
                                          {cbm}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{ color: "#360202",fontWeight:500 }}>
                                          CBM{" "}
                                          <span className="uom">
                                            (m<sup>3</sup>)
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm cft c-col-t-1">
                                          {cft}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          CFT{" "}
                                          <span className="uom">
                                            (ft<sup>3</sup>)
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm cyd c-col-t-1">
                                          {cyd}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500}}>
                                          Cubic Yard{" "}
                                          <span className="uom">
                                            (yd<sup>3</sup>)
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm cin c-col-t-1">
                                          {cin}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          Cubic Inch{" "}
                                          <span className="uom">
                                            (in<sup>3</sup>)
                                          </span>
                                        </p>
                                      </div>
                                      <div className="col-sm-5 text-center mt-1 c-col-100">
                                        <p className="fs-2 fw-bold m-0 lh-sm ccm c-col-t-1">
                                          {ccm}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          Cubic CM{" "}
                                          <span className="uom">
                                            (cm<sup>3</sup>)
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                    <hr className="mx-3 flex-grow-1 mb-0 bg-white" />
                                    <div className="row text-white justify-content-center mt-1 c-row">
                                      <p className="fs-6 text-center ylfont fw-bold m-0 c-col-t">
                                        Volumetric Weight (kg)
                                      </p>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm sea c-col-t-1">
                                          {sea}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          Volumetric Weight Sea
                                        </p>
                                      </div>
                                      <div className="col-sm-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm air c-col-t-1">
                                          {air}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500}}>
                                          Volumetric Weight Air
                                        </p>
                                      </div>
                                    </div>
                                    <hr className="mx-3 flex-grow-1 mb-0 bg-white" />
                                    <div className="row text-white justify-content-center mt-1 c-row">
                                      <p className="fs-6 text-center ylfont fw-bold m-0 c-col-t">
                                        Approximate Cartons
                                      </p>
                                      <div className="col-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm gt20 c-col-t-1">
                                          {gt20}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          20FT General
                                        </p>
                                      </div>
                                      <div className="col-5 text-center mt-1 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm gt40 c-col-t-1">
                                          {gt40}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          40FT General
                                        </p>
                                      </div>
                                      <div className="col-5 text-center mt-2 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm rt20 c-col-t-1">
                                          {rt20}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          20FT Reefer
                                        </p>
                                      </div>
                                      <div className="col-5 text-center mt-2 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm rt40 c-col-t-1">
                                          {rt40}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          40FT Reefer
                                        </p>
                                      </div>
                                      <div className="col-5 text-center mt-2 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm hc20 c-col-t-1">
                                          {hc20}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          20FT Highcube
                                        </p>
                                      </div>
                                      <div className="col-5 text-center mt-2 c-col">
                                        <p className="fs-2 fw-bold m-0 lh-sm hc40 c-col-t-1">
                                          {hc40}
                                        </p>
                                        <p className="fs-6 m-0 lblue c-col-text" style={{  color: "#360202",fontWeight:500 }}>
                                          40FT Highcube
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {activeTab === 'Incoterms' && (
                                <div className="calculator-form">
                                  <h2 className="calculator-title">Incoterms</h2>
                                  <div className="row">
                                    <div className="col-md-6">
                                      <div className="incoterms-image" style={{ marginBottom: "20px", cursor: "pointer" }} onClick={() => setIsOpen(true)} >
                                        <img 
                                          src="/assets/img/mittinco.png" 
                                          alt="Incoterms diagram" 
                                          style={{ 
                                            width: "100%", 
                                            height: "auto", 
                                            borderRadius: "8px",
                                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)"
                                          }} 
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6">
                                      <div className="accordion" id="incotermsAccordion">
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'EXW' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('EXW')}
                                              style={{
                                                background: activeAccordion === 'EXW' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'EXW' ? '#fff' : '#000'
                                              }}
                                            >
                                              EXW (Ex Works)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'EXW' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            Ex Works is when the seller places the goods at the disposal of the buyer at the seller's premises or at another designated place (i.e. factory, warehouse, etc.). The seller does not need to load the goods on any collection vehicle. He is also not required to clear them for export where this type of authorisation is valid.                                            </div>
                                          </div>
                                        </div>

                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'FCA' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('FCA')}
                                              style={{
                                                background: activeAccordion === 'FCA' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'FCA' ? '#fff' : '#000'
                                              }}
                                            >
                                              FCA (Free Carrier)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'FCA' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods to the carrier or other person appointed by the buyer at the seller's place of business or at another specified place. It is advisable for the parties to specify the point within the specified place of delivery as clearly as possible, since at this point the risk passes to the buyer.
                                            </div>
                                          </div>
                                        </div>

                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'CPT' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('CPT')}
                                              style={{
                                                background: activeAccordion === 'CPT' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'CPT' ? '#fff' : '#000'
                                              }}
                                            >
                                              CPT (Carriage Paid to)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'CPT' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods to the carrier or another person appointed by the seller at an agreed place (if such a place has been agreed between the parties). The seller must contract and pay the transport costs necessary to bring the goods to the specified destination.
                                            </div>
                                          </div>
                                        </div>

                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'CIP' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('CIP')}
                                              style={{
                                                background: activeAccordion === 'CIP' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'CIP' ? '#fff' : '#000'
                                              }}
                                            >
                                              CIP (Carriage and Insurance Paid to)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'CIP' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            It states that the seller will pay freight and insurance where mutually agreed. The seller shall arrange and pay for the buyer's comprehensive insurance against the risk of loss or damage to the goods from the port of shipment to at least the port of destination. When using CIP, the seller and buyer may agree on the provision of a lower level of insurance cover as part of their agreement.
                                            </div>
                                          </div>
                                        </div>

                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'DAP' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('DAP')}
                                              style={{
                                                background: activeAccordion === 'DAP' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'DAP' ? '#fff' : '#000'
                                              }}
                                            >
                                              DAP (Delivered at Place)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'DAP' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods when they are placed at the buyer's disposal in the transport vehicle, which arrives ready for unloading at the specified destination. The Seller assumes all risks associated with bringing the goods to the specified place.
                                            </div>
                                          </div>
                                        </div>
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'DDP' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('DDP')}
                                              style={{
                                                background: activeAccordion === 'DDP' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'DDP' ? '#fff' : '#000'
                                              }}
                                            >
                                              DDP (Delivered Duty Paid)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'DDP' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods when the goods are placed at the buyer's disposal, having been customs cleared for import on the arriving transport vehicle, ready for unloading at the specified destination. The seller bears all costs and risks associated with bringing the goods to the destination. They are obliged to clear the goods not only for export but also for import, to pay all kinds of taxes for both export and import and to carry out all customs clearance procedures.
                                            </div>
                                          </div>
                                        </div>
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'FAS' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('FAS')}
                                              style={{
                                                background: activeAccordion === 'FAS' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'FAS' ? '#fff' : '#000'
                                              }}
                                            >
                                              FAS (Free On Board)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'FAS' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods on board the vessel designated by the buyer at the specified port of loading or supplies the goods so delivered. The risk of loss or damage to the goods passes while the goods are on board. The buyer bears all costs from that moment on.
                                            </div>
                                          </div>
                                        </div>
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'CFR' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('CFR')}
                                              style={{
                                                background: activeAccordion === 'CFR' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'CFR' ? '#fff' : '#000'
                                              }}
                                            >
                                              CFR (Cost and Freight)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'CFR' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods on board or provides the delivered goods. The risk of loss or damage to the goods passes while the goods are on board. The seller must contract for and pay the costs and freight necessary to bring the goods to the specified port of destination.
                                            </div>
                                          </div>
                                        </div>
                                        <div className="accordion-item">
                                          <h2 className="accordion-header">
                                            <button 
                                              className={`accordion-button ${activeAccordion === 'CIF' ? '' : 'collapsed'}`}
                                              onClick={() => toggleAccordion('CIF')}
                                              style={{
                                                background: activeAccordion === 'CIF' ? '#c51524' : '#f8f9fa',
                                                color: activeAccordion === 'CIF' ? '#fff' : '#000'
                                              }}
                                            >
                                              CIF (Cost, Insurance and Freight)
                                            </button>
                                          </h2>
                                          <div className={`accordion-collapse collapse ${activeAccordion === 'CIF' ? 'show' : ''}`}>
                                            <div className="accordion-body">
                                            The seller delivers the goods on board or provides the delivered goods. The risk of loss or damage to the goods passes while the goods are on board. The seller must contract for and pay the costs and freight necessary to bring the goods to the specified port of destination. The seller also contracts for the buyer's insurance cover against the risk of loss or damage to the goods in transit. The buyer should note that under CIF the seller is only required to take out insurance to the extent of the minimum cover. If the buyer wishes to have more insurance protection, he will either have to agree so explicitly with the seller or make his own extra insurance arrangements.
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isOpen  && (
          <Lightbox
        open={isOpen}
        close={() => setIsOpen(false)}
        styles={{
          container: {
            backgroundColor: 'rgba(0, 0, 0, 0.6)',
          },
        }}
        slides={[{ src: "/assets/img/mitinco.png" }]}
        plugins={[Zoom]}
        controller={{
    closeOnPullDown: true,
    closeOnBackdropClick: true,
    navigation: false, // 👈 Okları gizler
  }}
    zoom={{
      maxZoomPixelRatio: 2, // Yakınlaştırma oranı
      zoomInMultiplier: 2,
      doubleTapDelay: 300,
      doubleClickDelay: 300,
      scrollToZoom: true, // Mouse scroll ile zoom
    }}
      />
)}
      </main>
      <footer className="footer__area fix">
        <div className="container">
          <div className="cta__wrap fix">
            <div className="row align-items-center">
              <div className="col-lg-7">
                <div className="cta__content">
                  <h3 className="title">
                    Fastest &amp; secure way to transport <br /> anything anytime
                  </h3>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta__btn text-end">
                <Link to="/getoffer" className="btn btn-two">
                    Request a Quote{" "}
                    <svg
                      width={13}
                      height={13}
                      viewBox="0 0 13 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      data-inject-url="https://themeadapt.com/tf/logistex/assets/img/right_arrow.svg"
                      className="injectable"
                    >
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1 12.0969L12.0969 0.999996M12.0969 0.999996H1M12.0969 0.999996V12.0969"
                        stroke="currentcolor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    </Link>
                </div>
              </div>
            </div>
            <div className="cta__shape">
              <img
                src="/assets/img/cta_shape.png"
                alt="img"
                data-aos="fade-up-right"
                data-aos-delay={400}
                className="aos-init"
              />
            </div>
          </div>
          <div className="footer__top">
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6">
                <div className="footer__widget">
                  <div className="footer__logo">
                  <Link to="/">
                        <img src="/assets/img/mtllogo.png" alt="Logo" />
                      </Link>
                  </div>
                  <div className="footer__content">
                    <p>
                    At MTL, we specialize in logistics solutions tailored to meet diverse delivery needs. 
                    </p>
                  </div>
                  <form onSubmit={handleSubscribe} className="footer__newsletter" style={{display: 'none'}}>
                    <div className="form-grp">
                      <input 
                        type="email" 
                        placeholder="enter your e-mail" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      <button type="submit">Subscribe</button>
                    </div>
                    <span>We don't send you any spam</span>
                  </form>
                </div>
              </div>
              <div className="col-xl-2 col-lg-4 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Our Services</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                      <Link to="/">Home</Link>
                      </li>
                      <li>
                      <Link to="/aboutus">About Us</Link>
                      </li>
                      <li>
                      <Link to="/services">Services</Link>
                      </li>
                      <li>
                      <Link to="/blog">Blog</Link>
                      </li>
                      <li>
                      <Link to="/getoffer">Get Offer</Link>
                      </li>
                      <li>
                      <Link to="/contact">Contact</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Other Logistics Companies</h4>
                  <div className="footer__link">
                    <ul className="list-wrap">
                      <li>
                         <a href="https://mitlog.com.tr/">Mitlog Logistics</a>
                      </li>
                      <li>
                        <a href="https://www.mitlog-airsea.com.tr/">Mitlog Air&Sea Logistics</a>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
                <div className="footer__widget">
                  <h4 className="footer__widget-title">Information</h4>
                  <div className="footer__info-wrap">
                    <ul className="list-wrap">
                      <li>
                        <i className="flaticon-location-1" />
                        <p>
                        8451 Market Street ste 138, <br /> Houston Texas 77029 , USA
                        </p>
                      </li>
                      <li>
                        <i className="flaticon-telephone" />
                        <a href="tel:+18325621002">(+1) 832 562 1002</a>
                      </li>
                      <li>
                        <i className="flaticon-time" />
                        <p>
                          Mon – Fri: 8.30- 17.30 EST
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer__bottom">
            <div className="row align-items-center">
              <div className="col-md-7">
                <div className="copyright-text">
                  <p>
                    Copyright @MTL | All Right
                    Reserved
                  </p>
                </div>
              </div>
              <div className="col-md-5">
                <div className="footer__social">
                  <ul className="list-wrap">
                  <li>
                        <a href="https://wa.me/18325621002" target="_blank">
                          <i className="fab fa-whatsapp" />
                        </a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/mtlshipinc" target="_blank">
                          <i className="fab fa-instagram" />
                        </a>
                      </li>
                
                  
                      <li>
                        <a href="https://www.linkedin.com/company/mtlship" target="_blank">
                          <i className="fab fa-linkedin-in" />
                        </a>
                      </li>
              <li/>
               
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer__shape">
          <img
            src="/assets/img/footer_shape01.png"
            alt="shape"
            data-aos="fade-down"
            data-aos-delay={400}
            className="aos-init"
          />
          <img
            src="/assets/img/footer_shape02.png"
            alt="shape"
            data-aos="fade-left"
            data-aos-delay={400}
            className="aos-init"
          />
        </div>
      </footer>

    </>
  );
}

export default Databank;

